import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  AddToCartAPI,
  AddtoCartItemsByJobId,
  LocalGlobalProductSearch,
  SearchProductsList,
} from "../service/AddCartJobs";
import {
  setOnChangeFunc,
  setOpenTypeofSupply,
  setSearchItemInput,
  setSelectCategory,
} from "../redux/feature/jobSlice";

import { useNavigate } from "react-router-dom";
import ReactLoading from "react-loading";
import { Container } from "react-bootstrap";
import { toast } from "react-toastify";
import { SelectPopup } from "../components/SelectPopup";
import placholder from "../assets/image/placholder.png";
import { faLeftLong } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const SearchItemsPage = () => {
  const [product, setProduct] = useState([]);
  const [loading, setLoading] = useState(true);
  const jobIdData = useSelector((state) => state.jobSlice.jobId);
  const onChangeFunc = useSelector((state) => state.jobSlice.onChangeFunc);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const searchItemInput = useSelector(
    (state) => state.jobSlice.searchItemInput
  );

  const userInfo = JSON.parse(localStorage.getItem("AUTH_USER"));
  const userRole = userInfo?.userRole;

  const searchKey = localStorage.getItem("SearchQuery");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const thirdpartyAccessData = localStorage.getItem("thirdpartyAccessData");

  const handleSearch = async () => {
    if (searchItemInput.length) {
      setLoading(true);
      try {
        const localResponse = await LocalGlobalProductSearch(
          userRole === "CompanyUser" ? userInfo.userId : customerUsersData,
          searchItemInput
        );

        if (localResponse?.data?.length !== 0) {
          const mappedLocalResponse = localResponse?.data.map((item) => ({
            proid: null,
            title: `${item.productName}, ${item.productDescription}`,
            price: item.amount,
            image: placholder,
          }));

          setProduct(mappedLocalResponse);
        } else if (thirdpartyAccessData === "true") {
          const response = await SearchProductsList(searchItemInput);

          const mappedThirdPartyResponse = response?.search_results?.map(
            (item) => ({
              proid: item.asin,
              title: item.title,
              price: item.price,
              image: item.image || placholder,
            })
          );
          setProduct(mappedThirdPartyResponse);
        } else {
          setProduct([]);
        }

        dispatch(setSearchItemInput(""));
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const filterData = product.filter((value) =>
    value.title?.toLowerCase().includes(searchKey.toLocaleLowerCase())
  );
  useEffect(() => {
    handleSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchItemInput]);
  const customerUsersData = useSelector(
    (state) => state.auth.customerUsersData
  );

  const openTypeofSupply = useSelector(
    (state) => state.jobSlice.openTypeofSupply
  );
  const selectCategory = useSelector((state) => state.jobSlice.selectCategory);

  const handleSelectedProduct = (item) => {
    setSelectedProduct(item);
    dispatch(setOpenTypeofSupply(true));
  };

  const handleAddtoCart = async () => {
    const cartDetails = {
      productName: selectedProduct?.title || selectedProduct?.productName,
      productPrice: selectedProduct?.price?.value ?? selectedProduct?.price,
      typeofSupply: selectCategory,
      quantity: 1,
      userId: userRole === "CompanyUser" ? userInfo.userId : customerUsersData,
    };

    if (jobIdData.id) {
      cartDetails.jobId = jobIdData.id;
    }

    if (selectCategory) {
      try {
        const response = jobIdData.id
          ? await AddtoCartItemsByJobId(cartDetails)
          : await AddToCartAPI(cartDetails);

        toast.success("Cart Added successfully" || response?.message);

        dispatch(setSelectCategory(""));
        dispatch(setOpenTypeofSupply(false));
        dispatch(setOnChangeFunc(false));

        if (response?.status) {
          setTimeout(() => {
            navigate("/cartListData");
          }, 1000);
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        console.error("Error adding to cart:", error);
        toast.error("Something went wrong, please try again.");
      }
    }
  };

  useEffect(() => {
    if (onChangeFunc) {
      handleAddtoCart();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectCategory, onChangeFunc]);
  return (
    <Container fluid className="p-0 my-3 ">
      <div className="d-flex justify-content-between align-items-center">
        <div className="main_title mb-2"> Product List</div>
        <div>
          {" "}
          <button
            className="btn btn-success mb-2"
            onClick={() => window.history.back()}
          >
            <FontAwesomeIcon icon={faLeftLong} /> Back
          </button>
        </div>
      </div>
      <div>
        {loading ? (
          <ReactLoading
            type={"bars"}
            color="#33995e"
            height={60}
            width={60}
            className={"globe_loader custom_loader"}
          />
        ) : (
          <>
            <div className=" mb-4">
              <div className="row g-3">
                {filterData?.length > 0 ? (
                  <>
                    {filterData.map((item, index) => (
                      <div className="col-md-3" key={index}>
                        <div
                          className="card  h-100"
                          style={{
                            boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                          }}
                        >
                          <div className="img-box d-flex justify-content-center align-items-center p-5">
                            <img
                              src={item.image}
                              alt={item.title}
                              style={{
                                width: "100%",
                                height: "250px",
                                display: "block",
                                objectFit: "contain",
                              }}
                            />
                          </div>
                          <div className="card-body">
                            <h5 className="pb-3 pt-3">
                              {item.title}
                              {/* {item.title.slice(0, 50) + "..."} */}
                            </h5>

                            <div className="d-flex justify-content-between align-items-center">
                              <h5 className="pb-3 pt-3">
                                ${item?.price?.value ?? item?.price}
                              </h5>
                              <button
                                className="btn btn-success"
                                onClick={() => handleSelectedProduct(item)}
                              >
                                {jobIdData.id ? "ADDED to CART" : "ADD TO CART"}
                              </button>
                            </div>
                            <div></div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                ) : (
                  <p>No products found</p>
                )}
              </div>
              {openTypeofSupply ? <SelectPopup /> : ""}
            </div>
          </>
        )}
      </div>
    </Container>
  );
};
